module.exports = __webpack_public_path__ + "img/visa.2bc1a543.png";